import { createContext, type PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import type { Site } from '@/api/fe-api/domain/entities/site';
import type { VehiclePreview } from '@/api/fe-api/domain/entities/vehicle';
import { GetOneSite } from '@/api/fe-api/view/queries/get-one-site';
import { GetOneVehiclePreview } from '@/api/fe-api/view/queries/get-one-vehicle-preview';
import { useMe } from '@/hooks/use-me';

export type CurrentAssetContextValue = {
  accureId?: string;
  asset: Site | null;
  assetId?: string; // TODO: Rename. This is only the id used in the URL, which maybe not be the ACCURE ID
  isMobility: boolean;
  vehicle: VehiclePreview | null;
  isLoading: boolean;
};

export const CurrentAssetContext = createContext<
  CurrentAssetContextValue | undefined
>(undefined);

type CurrentAssetProviderProps = PropsWithChildren<{}>;

export function CurrentAssetProvider({ children }: CurrentAssetProviderProps) {
  const { siteId } = useParams<{ siteId?: string }>();
  const me = useMe();
  const isMobility = me.config.type === 'mobility';
  const getOneSite = GetOneSite.useQuery(
    { id: siteId },
    { enabled: !isMobility },
  );
  const getOneVehicle = GetOneVehiclePreview.useQuery(
    { id: siteId },
    { enabled: isMobility },
  );

  return (
    <CurrentAssetContext.Provider
      value={{
        accureId: getOneVehicle.data?.isOk()
          ? getOneVehicle.data.value.id
          : getOneSite.data?.isOk()
            ? getOneSite.data.value.id
            : undefined,
        asset: getOneSite.data?.isOk() ? getOneSite.data.value : null,
        isLoading: isMobility ? getOneVehicle.isLoading : getOneSite.isLoading,
        assetId: siteId,
        isMobility,
        vehicle: getOneVehicle.data?.isOk() ? getOneVehicle.data.value : null,
      }}
    >
      {children}
    </CurrentAssetContext.Provider>
  );
}
